import React from 'react';
import axios from '../util/Api'

import { Alert, Tooltip, message , Row, Col, Input, Button, Slider, Checkbox, InputNumber, Progress } from 'antd';

import {
  BrowserRouter as Router,
  Route,
  Link
} from "react-router-dom";

import { verifIsLogged, getLanguage, setDisconnectMachineId, getMachineId, getPays, setLanguage} from "../util/Toolbox";

import './css/containersFormulaire.css';
import './css/navBar.css';

import { withTranslation } from 'react-i18next';
import ElectronWaterLinkService from '../services/ElectronWaterLinkService'
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';

class AvaForms extends React.Component {

  state = {

    IsFiltreASable : false,
    IsFiltreACartouche : false,
    IsFiltreADiatomee : false,
    IsPocheFiltration : true,

    TempsFiltration : undefined,
    TauxSelAppareil : undefined,
    TemperatureEau : undefined,
    VolumeBassin : '',

    IsTypeDesinfection_ChloreGalet : false,
    IsTypeDesinfection_Brome : false,
    IsTypeDesinfection_ChloreLiquide : false,
    IsTypeDesinfection_Eletrolyseur: false,

    IsHideEauCalcaire : true,
    IsTypeEau_MoyenneDure : false,
    IsTypeEau_Dure : false,
    IsTypeEau_TresDur : false,
    IsTypeEau_NeSaisPas : false,

    IsAspect_EauClaire : false,
    IsAspect_EauTrouble : false,
    IsAspect_EauVerte : false,

    loadingButton: false,

    IsAnalysePro : true,
    IsEnCoursDeSaison : false,
    ReferenceAnalyse : '',

    ValeurPH : 7.6,
    ValeurChloreLibre : -1,

    guid_compte: 'fsdfsdsdfsdfsd',

    language : getLanguage(),
    languages_LIST : [],
    isElectron: false,
    valeurInputMode: 'manual',
    spintouchStatus: null,
    spintouchLoading: false,
    spintouchError: null,
    spintouchResults: null,
    spintouchProgress: 0

  }


  async componentDidMount() {

    // Récupèration des paramètres dans l'URL si il y en a
    const search  = window.location.search;
    const params  = new URLSearchParams(search);
    const volume  = params.get('volume');

    verifIsLogged();

    let languages_LIST = getPays();
    
    this.setState({languages_LIST : languages_LIST});

    let guid_compte = getMachineId();

    this.state.guid_compte = guid_compte;

    const {i18n } = this.props;
    let newLang = getLanguage();
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    this.setState({language : newLang});

    const isElectron = ElectronWaterLinkService.isElectronApp();
    this.setState({ isElectron });

// pour les tests.
   // this.setState({ isElectron : true });


    if(volume != null){
      this.setState({VolumeBassin: volume});
    }

    let savedReference = localStorage.getItem('ReferenceAnalyse');
    if(savedReference){
      this.setState({ReferenceAnalyse: savedReference});
    }

  }

  componentWillUnmount() {
    if (this.spintouchIntervalId) {
      clearInterval(this.spintouchIntervalId);
      this.spintouchIntervalId = null;
    }
  }

  // Fonction pour changer la langue
  handleChangeLanguage = (event) => {
    const newLang = event.target.value;
    // Définir la langue  
    const {i18n } = this.props;
    console.log(newLang);
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    this.setState({language : newLang});
  };

  // Spintouch helpers
  setSpintouchFieldIfPresent(name, value) {
    if (typeof value === 'number' && !isNaN(value)) {
      this.setState({ [name]: value });
    }
  }

  parseSpintouchResult(result) {
    const toNum = (v) => {
      if (typeof v === 'number') return v;
      if (typeof v === 'string') {
        const n = parseFloat(v.replace(',', '.'));
        return isNaN(n) ? undefined : n;
      }
      return undefined;
    };

    // 1) Format officiel: result.Results[] avec FactorCode/Value
    if (result && Array.isArray(result.Results)) {
      const byCode = (code) => {
        const f = result.Results.find(r => r && (r.FactorCode === code || r.factorCode === code));
        return f ? toNum(f.Value ?? f.value ?? f.Result ?? f.result) : undefined;
      };
      // fallback par nom au cas où FactorCode non présent
      const byName = (substr) => {
        const f = result.Results.find(r => r && typeof r.Name === 'string' && r.Name.toLowerCase().includes(substr));
        return f ? toNum(f.Value ?? f.value ?? f.Result ?? f.result) : undefined;
      };

      return {
        ph: byCode(8) ?? byName('ph'),
        freeChlorine: byCode(2) ?? byName('chlore libre') ?? byName('free chlorine'),
        bromine: byCode(5) ?? byName('brome') ?? byName('bromine'),
        tac: byCode(9) ?? byName('alcal') ?? byName('alkal'),
        th: byCode(10) ?? byName('duret') ?? byName('hardness'),
        stabilizer: byCode(12) ?? byName('stabil'),
        phosphate: byCode(18) ?? byName('phosph')
      };
    }

    // 2) Autres formats éventuels (compatibilité)
    const collections = [result, result && result.data, result && result.results, result && result.factors];
    const extractByCodeLoose = (code) => {
      for (const coll of collections) {
        if (!coll) continue;
        if (Array.isArray(coll)) {
          const f = coll.find((x) => x && (x.code === code || x.factorCode === code || x.FactorCode === code || x.id === code));
          if (f) return toNum(f.Value ?? f.value ?? f.Result ?? f.result);
        } else if (typeof coll === 'object') {
          const v = coll[code];
          if (v != null) return toNum(v);
        }
      }
      return undefined;
    };

    return {
      ph: extractByCodeLoose(8),
      freeChlorine: extractByCodeLoose(2),
      bromine: extractByCodeLoose(5),
      tac: extractByCodeLoose(9),
      th: extractByCodeLoose(10),
      stabilizer: extractByCodeLoose(12),
      phosphate: extractByCodeLoose(18)
    };
  }

  utiliserResultatsSpintouch = () => {
    const { spintouchResults } = this.state;
    if (!spintouchResults) {
      message.warning('Aucun résultat à utiliser');
      return;
    }
    const parsed = this.parseSpintouchResult(spintouchResults || {});

    this.setState({
      ValeurPH: parsed.ph,
      ValeurChloreLibre: parsed.freeChlorine,
      ValeurBrome: parsed.bromine,
      ValeurTAC: parsed.tac,
      ValeurTH: parsed.th,
      ValeurStabilisant: parsed.stabilizer,
      ValeurPhosphate: parsed.phosphate
    });

    this.setSpintouchFieldIfPresent('ValeurPH', parsed.ph);
    this.setSpintouchFieldIfPresent('ValeurChloreLibre', parsed.freeChlorine);
    this.setSpintouchFieldIfPresent('ValeurBrome', parsed.bromine);
    this.setSpintouchFieldIfPresent('ValeurTAC', parsed.tac);
    this.setSpintouchFieldIfPresent('ValeurTH', parsed.th);
    this.setSpintouchFieldIfPresent('ValeurStabilisant', parsed.stabilizer);
    this.setSpintouchFieldIfPresent('ValeurPhosphate', parsed.phosphate);
    this.setState({ valeurInputMode: 'manual' });
    message.success('Résultats appliqués au formulaire');
  }

  async lancerAnalyseSpintouch() {
    if (!this.state.isElectron) {
      message.error('Disponible uniquement sous Electron');
      return;
    }
    this.setState({ spintouchLoading: true, spintouchError: null, spintouchStatus: 'Initialisation…', spintouchProgress: 0 });
    if (this.spintouchIntervalId) {
      clearInterval(this.spintouchIntervalId);
      this.spintouchIntervalId = null;
    }
    this.spintouchIntervalId = setInterval(() => {
      this.setState((prev) => {
        const next = Math.min(120, (prev.spintouchProgress || 0) + 1);
        return { spintouchProgress: next };
      });
    }, 1000);
    try {
      // Vérifie l’API exposée par le preload
      if (!(window && window.electronAPI)) {
        throw new Error('API Electron non disponible (preload non chargé)');
      }

      if (typeof window.electronAPI.checkService !== 'function') {
        console.warn('electronAPI.checkService manquant');
      } else {
        await ElectronWaterLinkService.checkService();
      }

      this.setState({ spintouchStatus: 'Service disponible, vérification de l’appareil…' });

      // Statut appareil si dispo
      if (typeof window.electronAPI.getStatus === 'function') {
        try {
          const status = await ElectronWaterLinkService.getStatus();
          this.setState({ spintouchStatus: `Statut appareil: ${ElectronWaterLinkService.getStatusText ? ElectronWaterLinkService.getStatusText(status) : status}` });
        } catch (e) {
          console.warn('Impossible de récupérer le statut:', e);
        }
      }

      // Récupère les options pour sélectionner des paramètres compatibles
      let reagent = 0;
      let sample = 0;
      if (typeof window.electronAPI.getOptions === 'function') {
        try {
          const options = await ElectronWaterLinkService.getOptions();
          const reagents = options && options.ReagentTypes ? options.ReagentTypes : [];
          const samples = options && options.SampleTypes ? options.SampleTypes : [];
          if (reagents.length > 0 && samples.length > 0) {
            // Cherche une paire compatible via Tags
            let chosenReagent = reagents[0];
            let chosenSample = samples[0];
            for (const r of reagents) {
              const compatible = samples.find(s => Array.isArray(s.Tags) && Array.isArray(r.Tags) && s.Tags.some(tag => r.Tags.includes(tag)));
              if (compatible) {
                chosenReagent = r;
                chosenSample = compatible;
                break;
              }
            }
            reagent = chosenReagent.Value != null ? chosenReagent.Value : reagent;
            sample = chosenSample.Value != null ? chosenSample.Value : sample;
          }
        } catch (e) {
          console.warn('Impossible de récupérer les options:', e);
        }
      }
      if (typeof window.electronAPI.runTest !== 'function') {
        throw new Error('electronAPI.runTest indisponible');
      }
      this.setState({ spintouchStatus: 'Analyse en cours…' });
      const result = await ElectronWaterLinkService.runWaterTest(reagent, sample);
      this.setState({ spintouchResults: result });

      const parsed = this.parseSpintouchResult(result || {});
      this.setSpintouchFieldIfPresent('ValeurPH', parsed.ph);
      this.setSpintouchFieldIfPresent('ValeurChloreLibre', parsed.freeChlorine);
      this.setSpintouchFieldIfPresent('ValeurBrome', parsed.bromine);
      this.setSpintouchFieldIfPresent('ValeurTAC', parsed.tac);
      this.setSpintouchFieldIfPresent('ValeurTH', parsed.th);
      this.setSpintouchFieldIfPresent('ValeurStabilisant', parsed.stabilizer);
      this.setSpintouchFieldIfPresent('ValeurPhosphate', parsed.phosphate);

      message.success('Mesures Spintouch importées');
    } catch (err) {
      const msg = (err && err.message) ? err.message : 'Erreur Spintouch';
      this.setState({ spintouchError: msg });
      message.error(msg);
    } finally {
      if (this.spintouchIntervalId) {
        clearInterval(this.spintouchIntervalId);
        this.spintouchIntervalId = null;
      }
      this.setState({ spintouchLoading: false, spintouchProgress: 120 });
    }
  }

  // Péride de l'analyse
  onChangedebutSaison = (e: CheckboxChangeEvent) => {
  //  this.resetTypeDesinfection();

    console.log(e.target.checked);
    this.setState({IsEnCoursDeSaison:e.target.checked})
  };


  onChangedebutSaison2 = (e: CheckboxChangeEvent) => {
  //  this.resetTypeDesinfection();

    console.log(e.target.checked);
    this.setState({IsEnCoursDeSaison:!e.target.checked})
  };

  // Type Filtration
  onChangeTypeFiltration_Sable = (e: CheckboxChangeEvent) => {
    this.resetTypeFiltration();
    this.setState({IsFiltreASable:e.target.checked})
  };

  onChangeTypeFiltration_Cartouche = (e: CheckboxChangeEvent) => {
    this.resetTypeFiltration();
    this.setState({IsFiltreACartouche:e.target.checked})
  };

  onChangeTypeFiltration_Diatomee = (e: CheckboxChangeEvent) => {
    this.resetTypeFiltration();
    this.setState({IsFiltreADiatomee:e.target.checked})
  };

  onChangeTypeFiltration_Filtration = (e: CheckboxChangeEvent) => {
    this.resetTypeFiltration();
    this.setState({IsPocheFiltration:e.target.checked})
  };



  // Type désinfection
  onChangeTypeDesinfection_ChloreGalet = (e: CheckboxChangeEvent) => {
    this.resetTypeDesinfection();
    this.setState({IsTypeDesinfection_ChloreGalet:e.target.checked})
  };

  onChangeTypeDesinfection_Brome = (e: CheckboxChangeEvent) => {
    this.resetTypeDesinfection();
    this.setState({IsTypeDesinfection_Brome:e.target.checked})
  };

  onChangeTypeDesinfection_ChloreLiquide = (e: CheckboxChangeEvent) => {
    this.resetTypeDesinfection();
    this.setState({IsTypeDesinfection_ChloreLiquide:e.target.checked})
  };

  onChangeTypeDesinfection_Electrolyseur = (e: CheckboxChangeEvent) => {
    this.resetTypeDesinfection();
    this.setState({IsTypeDesinfection_Eletrolyseur:e.target.checked})
  };


  // Type eau
  onChangeTypeEau_MoyenneDure = (e: CheckboxChangeEvent) => {
    this.resetTypeEau();
    this.setState({IsTypeEau_MoyenneDure:e.target.checked, ValeurTH : parseFloat(149) })
  };

  onChangeTypeEau_Dure = (e: CheckboxChangeEvent) => {
    this.resetTypeEau();
    this.setState({IsTypeEau_Dure:e.target.checked, ValeurTH : parseFloat(249) })
  };

  onChangeTypeEau_TresDure = (e: CheckboxChangeEvent) => {
    this.resetTypeEau();
    this.setState({IsTypeEau_TresDur:e.target.checked, ValeurTH : parseFloat(399) })
  };

  onChangeTypeEau_NeSaisPas = (e: CheckboxChangeEvent) => {
    this.resetTypeEau();
    this.setState({IsTypeEau_NeSaisPas:e.target.checked})
  };


  // Aspect de l'Eau
  onChangeAspectEau_Transparent = (e: CheckboxChangeEvent) => {
    this.resetTypeAspectEau();
    this.setState({IsAspect_EauClaire:e.target.checked})
  };

  onChangeAspectEau_Trouble= (e: CheckboxChangeEvent) => {
    this.resetTypeAspectEau();
    this.setState({IsAspect_EauTrouble:e.target.checked})
  };

  onChangeAspectEau_Verte= (e: CheckboxChangeEvent) => {
    this.resetTypeAspectEau();
    this.setState({IsAspect_EauVerte:e.target.checked})
  };

  handleChangeValue(dataType, value) {

    this.setState({[dataType]: value});
  }




  // Reset fonction
  resetTypeFiltration(){
    this.setState({IsFiltreASable : false, IsFiltreACartouche : false, IsFiltreADiatomee: false, IsPocheFiltration : false, loadingButton : false  })
  }

  resetTypeDesinfection(){
    this.setState({IsTypeDesinfection_ChloreGalet : false, IsTypeDesinfection_ChloreLiquide : false, IsTypeDesinfection_Brome: false, IsTypeDesinfection_Eletrolyseur : false,  loadingButton : false    })
  }

  resetTypeEau(){
    this.setState({IsTypeEau_MoyenneDure : false, IsTypeEau_Dure : false, IsTypeEau_TresDur: false, IsTypeEau_NeSaisPas : false ,  loadingButton : false   })
  }

  resetTypeAspectEau(){
    this.setState({IsAspect_EauClaire : false, IsAspect_EauTrouble : false, IsAspect_EauVerte: false,  loadingButton : false   })
  }



  // Bouton formulaire
  validationFormulaire = () => {
    const { t } = this.props;

    if(!this.state.VolumeBassin > 0){
      message.warning(t('validation_volume_bassin'));
      return;
    }

    if(this.state.IsFiltreASable == false && this.state.IsFiltreACartouche == false && this.state.IsFiltreADiatomee == false && this.state.IsPocheFiltration == false ){
      message.warning(t('validation_type_filtration'));
      return;
    }

    if(!this.state.TempsFiltration > 0){
      message.warning(t('validation_temps_filtration'));
      return;
    }


    if(this.state.IsTypeDesinfection_ChloreGalet == false && this.state.IsTypeDesinfection_Brome == false && this.state.IsTypeDesinfection_ChloreLiquide == false && this.state.IsTypeDesinfection_Eletrolyseur == false ){
      message.warning(t('validation_type_desinfection'));
      return;
    }
  
    if(!this.state.IsHideEauCalcaire && this.state.IsTypeEau_MoyenneDure == false && this.state.IsTypeEau_Dure == false && this.state.IsTypeEau_TresDur == false && this.state.IsTypeEau_NeSaisPas == false ){
      message.warning(t('validation_eau_calcaire'));
      return;
    }

    if(this.state.IsAspect_EauClaire == false && this.state.IsAspect_EauTrouble == false && this.state.IsAspect_EauVerte == false  ){
      message.warning(t('validation_aspect_eau'));
      return;
    }

    if(!this.state.TemperatureEau > 0){
      message.warning(t('validation_temperature_eau'));
      return;
    }

    if(this.state.IsTypeDesinfection_ChloreGalet == true){

        console.log(this.state.ValeurChloreLibre);

        if(this.state.ValeurChloreLibre >= 0) {

        }else{
          message.warning(t('validation_niveau_chlore'));
          return;
        }
    }



    this.setState({ loadingButton: true });

    // analyse
    if(this.state.ValeurChloreLibre <= 0){
      this.state.ValeurChloreLibre = null;
    }



    const messageIndicator = message.loading(t('validation_analyse_en_cours'), 0);

    let formulaire = {
      TemperatureEau : this.state.TemperatureEau,
      TempsFiltration : this.state.TempsFiltration
    }

    console.log(this.state)


      // APPEL API
    axios.post('/analyse/createAnalyse', {analyse : this.state},
    ).then(({data}) => {
      console.log(data);
      console.log(data.result)
      console.log(data.GUIDAnalyse)

      window.location.href= '/analyse?analyse='+ data.GUIDAnalyse;
      this.setState({ loadingButton: false });

      setTimeout(messageIndicator, 10);
    }).catch((error) => {
      const { t } = this.props;
      setTimeout(messageIndicator, 10);
      this.setState({ loadingButton: false });
      console.log("Error****:", error.message);
      message.error(t('validation_erreur_analyse'));
    });



  };


  onChangeSlider = (dataType, value) => {

    this.setState({[dataType]: parseFloat(value)});
  }


  render() {

    const { t, i18n } = this.props; // Récupérer la traduction et le changement de langue

      return (

        <div className = "wrapper_analyse">

          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

          <NavBar
            t={t}
            isElectron={false}
            updateStatus="current"
            IsAdmin={false}
          />
            <div>
              <div className = "containersFormulaire">

                <Row style = {{marginTop:10, marginBottom:20}}>
                  <Col sm={24} xs={24}>
                  { this.state.IsAnalysePro == true &&
                    <div className = "referenceAnalyse">
                     <Input placeholder={t('form_pref_placecorder')} value={this.state.ReferenceAnalyse} onChange={(event) => { this.setState({ReferenceAnalyse: event.target.value}); localStorage.setItem('ReferenceAnalyse', event.target.value); }}/>
                    </div>
                  }
                  </Col>
                </Row>

                <div>
                    <h4>{t('form_volume_bassin')}</h4>
                    <div className="fondFormulaire">
                    <Row gutter = {8}>
                      <Col sm={12} xs={12}>
                        <p>{t('form_volume_bassin_1')}</p>
                      </Col>
                      <Col sm={10} xs={10} className = "fondFormulaireFont" >
                        <InputNumber min={1} max={10000} style= {{marginTop: 10, width : '100%'}} value={this.state.VolumeBassin} onChange={(event) => this.setState({VolumeBassin: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                      </Col>
                      <Col sm={2} xs={2}>
                        <p>m³</p>
                      </Col>
                    </Row>

                    <p style = {{marginTop:20}}>{t('form_volume_bassin_2')}
                    <Link to="/simulateur"><Button style={{marginLeft: 16, backgroundColor: '#0C4457', color: 'white', fontWeight : 700}}>{t('form_volume_bassin_3')}</Button></Link>
                    </p>
                    </div>
                </div>

                <div>
                  <h4>{t('form_periode_analyse')}</h4>
                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {Boolean(!this.state.IsEnCoursDeSaison) }  onChange={this.onChangedebutSaison2}>{t('form_periode_analyse_1')}</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {Boolean(this.state.IsEnCoursDeSaison)} onChange={this.onChangedebutSaison}>{t('form_periode_analyse_2')}</Checkbox>
                    </Col>
                  </Row>
                </div>
                </div>

                <div>
                  <h4>{t('form_type_filtration')}</h4>
                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsFiltreASable}  onChange={this.onChangeTypeFiltration_Sable}>{t('form_type_filtration_1')}</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsFiltreADiatomee} onChange={this.onChangeTypeFiltration_Diatomee}>{t('form_type_filtration_2')}</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsFiltreACartouche} onChange={this.onChangeTypeFiltration_Cartouche}>{t('form_type_filtration_3')}</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsPocheFiltration} onChange={this.onChangeTypeFiltration_Filtration}>{t('form_type_filtration_4')}</Checkbox>
                    </Col>
                  </Row>
                  <p style = {{textAlign: 'center', marginBottom:0}}>{t('form_type_filtration_5')}</p>
                  <InputNumber value = {this.state.TempsFiltration}  placeholder = {t('form_type_filtration_6')} style={{width: '100%', marginTop : 0, color: 'blue'}} min={1} max={24}  onChange={(event) => this.setState({TempsFiltration: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                  </div>
                </div>

                <div>
                  <h4>{t('form_type_desinfection')}</h4>
                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeDesinfection_ChloreGalet}  onChange={this.onChangeTypeDesinfection_ChloreGalet}>{t('form_type_desinfection_1')}</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeDesinfection_ChloreLiquide} onChange={this.onChangeTypeDesinfection_ChloreLiquide}>{t('form_type_desinfection_2')}</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeDesinfection_Eletrolyseur} onChange={this.onChangeTypeDesinfection_Electrolyseur}>{t('form_type_desinfection_3')}</Checkbox>
                    </Col>
                  </Row>
                  {this.state.IsTypeDesinfection_Eletrolyseur == true &&
                    <InputNumber value = {this.state.TauxSelAppareil}  placeholder = {t('form_type_desinfection_4')} style={{width: '100%', marginTop : 0, color: 'blue'}} min={1} onChange={(event) => this.setState({TauxSelAppareil: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                  }
                  </div>
                </div>

                {!this.state.IsHideEauCalcaire && (
                <div>
                  <h4>{t('form_type_eau_calcaire')}</h4>
                  <div className="fondFormulaire">
                    <Row gutter = {8}>
                      <Col sm={12} xs={12}>
                        <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeEau_MoyenneDure}  onChange={this.onChangeTypeEau_MoyenneDure}>{t('form_type_eau_calcaire_1')}<span className = "checkBoxFormSpan">{t('form_type_eau_calcaire_1_1')}</span></Checkbox>
                      </Col>
                      <Col sm={12} xs={12}>
                        <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeEau_Dure} onChange={this.onChangeTypeEau_Dure}> {t('form_type_eau_calcaire_2')} <span className = "checkBoxFormSpan">{t('form_type_eau_calcaire_2_2')}</span></Checkbox>
                      </Col>
                      <Col sm={12} xs={12}>
                        <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeEau_TresDur} onChange={this.onChangeTypeEau_TresDure}> {t('form_type_eau_calcaire_3')} <span className = "checkBoxFormSpan">{t('form_type_eau_calcaire_3_3')}</span></Checkbox>
                      </Col>
                      <Col sm={12} xs={12}>
                        <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeEau_NeSaisPas} onChange={this.onChangeTypeEau_NeSaisPas}>{t('form_type_eau_calcaire_4')}</Checkbox>
                      </Col>
                    </Row>
                  </div>
                </div>
                )}

                <div>
                  <h4>{t('form_aspect_eau')}</h4>
                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={24} xs={24}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsAspect_EauClaire}  onChange={this.onChangeAspectEau_Transparent}> {t('form_aspect_eau_1')}</Checkbox>
                    </Col>
                    <Col sm={24} xs={24}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsAspect_EauTrouble} onChange={this.onChangeAspectEau_Trouble}>{t('form_aspect_eau_2')}</Checkbox>
                    </Col>
                    <Col sm={24} xs={24}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsAspect_EauVerte} onChange={this.onChangeAspectEau_Verte}>{t('form_aspect_eau_3')}</Checkbox>
                    </Col>
                  </Row>
                  </div>
                </div>

                <div>
                  <h4>{t('form_temperature_eau')}</h4>
                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={24} xs={24}>
                        <InputNumber value = {this.state.TemperatureEau}  placeholder = {t('form_temperature_eau')} style={{width: '100%', marginTop : 0, color: 'blue'}} min={1} onChange={(event) => this.setState({TemperatureEau: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                    </Col>
                  </Row>
                  </div>
                </div>

                <div>
                 
                  <h4>{t('form_valeur_mesure')}</h4>
                  { (
                    <div style={{ display: 'flex', gap: 16, alignItems: 'center', justifyContent: 'center', margin: '8px 0 12px 0' }}>
                      <div
                        onClick={() => this.setState({ valeurInputMode: 'manual' })}
                        style={{ cursor: 'pointer', textAlign: 'center', padding: 12, borderRadius: 8, backgroundColor: this.state.valeurInputMode === 'manual' ? '#90CAF9' : '#E3F2FD', border: this.state.valeurInputMode === 'manual' ? 'none' : '1px solid #ddd', minWidth: 200, display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}
                        title={t('form_valeur_input_manual_tooltip')}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="#2B4570"/>
                        </svg>
                        <Tooltip title={t('form_valeur_input_manual_tooltip')}>
                             <div style={{ fontWeight: 600, color: '#2B4570' }}>{t('form_valeur_input_manual')}</div>
                        </Tooltip>
                        
                      </div>
                      <Tooltip title={this.state.isElectron ? t('form_valeur_input_spintouch_tooltip') : t('form_valeur_input_spintouch_disabled')}>
                      <div
                        onClick={() => this.state.isElectron && this.setState({ valeurInputMode: 'spintouch' })}
                        style={{ 
                          cursor: this.state.isElectron ? 'pointer' : 'not-allowed', 
                          textAlign: 'center', 
                          padding: 12, 
                          borderRadius: 8, 
                          backgroundColor: !this.state.isElectron ? '#E0E0E0' : (this.state.valeurInputMode === 'spintouch' ? '#90CAF9' : '#E3F2FD'), 
                          border: this.state.valeurInputMode === 'spintouch' ? 'none' : '1px solid #ddd', 
                          minWidth: 200, 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: 8, 
                          justifyContent: 'center',
                          opacity: this.state.isElectron ? 1 : 0.6
                        }}
                        title={this.state.isElectron ? t('form_valeur_input_spintouch_tooltip') : t('form_valeur_input_spintouch_disabled')}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="7" y="4" width="10" height="5" rx="1" fill={this.state.isElectron ? "#2B4570" : "#9E9E9E"}/>
                          <rect x="8" y="5" width="2" height="1" fill={this.state.isElectron ? "#E3F2FD" : "#BDBDBD"}/>
                          <rect x="10.5" y="5" width="2" height="1" fill={this.state.isElectron ? "#E3F2FD" : "#BDBDBD"}/>
                          <path d="M6 9h12v9c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V9z" fill={this.state.isElectron ? "#2B4570" : "#9E9E9E"}/>
                          <path d="M8 11h8v5H8v-5z" fill={this.state.isElectron ? "#E3F2FD" : "#BDBDBD"}/>
                          <path d="M11.5 12.5l-1.5 3h3l-1.5-3z" fill="#FFFFFF" stroke={this.state.isElectron ? "#2B4570" : "#9E9E9E"} strokeWidth="0.5"/>
                        </svg>
                        <div style={{ fontWeight: 600, color: this.state.isElectron ? '#2B4570' : '#9E9E9E' }}>{t('form_valeur_input_spintouch')}</div>
                      </div>
                      </Tooltip>
                    </div>
                  )}
                  { this.state.isElectron == true && this.state.valeurInputMode === 'spintouch' && (
                    <div className="fondFormulaire" style={{ marginBottom: 12, marginTop: 12 }}>
                      <Row gutter={8}>
                        <Col sm={24} xs={24}>
                          <p style={{ marginBottom: 8 }}>Lancer une analyse Spintouch pour importer automatiquement les mesures.</p>
                          
                          { this.state.spintouchError && <p style={{ color: 'red', marginBottom: 8 }}>{this.state.spintouchError}</p> }
                          <Button onClick={this.lancerAnalyseSpintouch.bind(this)} loading={this.state.spintouchLoading} style={{ backgroundColor: '#FFDD00', color: '#005A9D', fontWeight: 700 }}>
                            Lancer une analyse Spintouch
                          </Button>

                          { (this.state.spintouchLoading || (this.state.spintouchProgress > 0 && this.state.spintouchProgress < 120)) && (
                            <div style={{ marginTop: 12 }}>
                              <Progress percent={Math.round((this.state.spintouchProgress / 65) * 100)} status="active" strokeColor="#FFFFFF" />
                            </div>
                          )}

                          {/* Résultats du test */}
                          { this.state.spintouchResults && (
                            <div style={{ marginTop: 16 }}>
                              <h5 style={{ marginBottom: 8 }}>Résultats</h5>
                              { Array.isArray(this.state.spintouchResults.Results) && this.state.spintouchResults.Results.length > 0 ? (
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 8 }}>
                                  <div style={{ fontWeight: 600 }}>Paramètre</div>
                                  <div style={{ fontWeight: 600 }}>Valeur</div>
                                  <div style={{ fontWeight: 600 }}>Unités</div>
                                  <div style={{ fontWeight: 600 }}>Facteur</div>
                                  { this.state.spintouchResults.Results.map((r, idx) => (
                                    <React.Fragment key={idx}>
                                     
                                      <div>{r.Name || '-'}</div>
                                      <div>{typeof r.Value === 'number' ? r.Value.toFixed(r.Decimals || 0) : (r.Value ?? '-')}</div>
                                      <div>{r.Units || '-'}</div>
                                      <div>{r.FactorCode != null ? r.FactorCode : '-'}</div>
                                    </React.Fragment>
                                  ))}
                                </div>
                              ) : (
                                <div style={{ color: 'white' }}>

                                 
                                  <Alert
                                    title="Warning"
                                    description={t('form_spintouch_non_detect')}
                                    type="warning"
                                    showIcon
                                    closable
                                  />
                                </div>
                              )}
                              <div style={{ marginTop: 12 }}>
                                <Button type="primary" onClick={this.utiliserResultatsSpintouch}>
                                  Utiliser les résultats
                                </Button>
                              </div>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}
                  { ((this.state.isElectron == true ? this.state.valeurInputMode === 'manual' : true)) && (
                  <div className = "valeur_mesuree">
                    <div className='valeur_mesuree_wrapper_item'>
                      <h5 style = {{paddingTop:8}}>{t('form_valeur_mesure_PH')}</h5>
                      <div className = "valeur_mesuree_item">
                      <InputNumber style = {{color : 'black', marginBottom : '2px'}} min={6} max={9}  step={0.1} value={this.state.ValeurPH} defaultValue={this.state.ValeurPH} onChange={(event) => this.setState({ValeurPH: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                        <Row>
                          <Col className = "valeur_mesuree_left" span={5} style = {{backgroundColor : "#FFCFA7", height:20}} ></Col>
                          <Col span={5} style = {{backgroundColor : "#FFB074",  height:20}}></Col>
                          <Col span={4} style = {{backgroundColor : "#FF9848", height:20}}></Col>
                          <Col span={5} style = {{backgroundColor : "#FF6C1D", height:20}}></Col>
                          <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#E96C1A", height:20}}></Col>
                        </Row>
                        <Slider value ={this.state.ValeurPH} onChange={this.onChangeSlider.bind(this, 'ValeurPH')} style = {{marginTop:-16}}  min={6} max={9} defaultValue={this.state.ValeurPH}  step={0.1} trackStyle={{ backgroundColor: 'blue' }} handleStyle={{ borderColor: 'blue' }}  />
                      </div>
                    </div>
                   

                    {
                      (this.state.IsTypeDesinfection_ChloreGalet == true || this.state.IsTypeDesinfection_ChloreLiquide == true || this.state.IsTypeDesinfection_Eletrolyseur == true)   &&
                      (
                        <div className='valeur_mesuree_wrapper_item'>
                          <h5 style = {{paddingTop:8}}> {t('form_valeur_mesure_CL')} </h5>
                          <div className = "valeur_mesuree_item">
                          <InputNumber style = {{color : 'black', marginBottom : '2px'}} value={this.state.ValeurChloreLibre} min={-1} max={3}  step={0.1} defaultValue={this.state.ValeurChloreLibre} onChange={(event) => this.setState({ValeurChloreLibre: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                            <Row>
                              <Col className = "valeur_mesuree_left" span={5} style = {{backgroundColor : "#DAAEDC", height:20}} ></Col>
                              <Col span={5} style = {{backgroundColor : "#D979DC", height:20}}></Col>
                              <Col span={4} style = {{backgroundColor : "#D051DB", height:20}}></Col>
                              <Col span={5} style = {{backgroundColor : "#BA32B6", height:20}}></Col>
                              <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#9C1F91", height:20}}></Col>
                            </Row>
                            <Slider onChange={this.onChangeSlider.bind(this, 'ValeurChloreLibre')} style = {{marginTop:-16}}  min={0} max={3} defaultValue={this.state.ValeurChloreLibre}  step={0.1}  />
                          </div>
                        </div>
                      )
                    }

                    {
                      this.state.IsTypeDesinfection_Brome == true &&
                      (
                        <div  className='valeur_mesuree_wrapper_item'>
                          <h5 style = {{paddingTop:8}}> {t('form_valeur_mesure_BR')}</h5>
                          <div className = "valeur_mesuree_item">
                          <InputNumber style = {{color : 'black',marginBottom : '2px'}} min={0} max={3} defaultValue={this.state.ValeurBrome} onChange={(event) => this.setState({ValeurBrome: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                            <Row>
                              <Col className = "valeur_mesuree_left" span={5} style = {{backgroundColor : "#DAAEDC", height:20}} ></Col>
                              <Col span={5} style = {{backgroundColor : "#D979DC"}}></Col>
                              <Col span={4} style = {{backgroundColor : "#D051DB"}}></Col>
                              <Col span={5} style = {{backgroundColor : "#BA32B6"}}></Col>
                              <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#9C1F91"}}></Col>
                            </Row>
                            <Slider onChange={this.onChangeSlider.bind(this, 'ValeurBrome')} style = {{marginTop:-16}}  min={0} max={3} defaultValue={2}  step={0.1}  />
                          </div>
                        </div>
                      )
                    }

                    <div className='valeur_mesuree_wrapper_item'> 
                      <h5 style = {{paddingTop:8}}> {t('form_valeur_mesure_TAC')}  <span style= {{fontWeight: 400}}>  {t('form_valeur_mesure_TAC_facultatif')}   </span></h5>
                      <div className = "valeur_mesuree_item">
                      <InputNumber style = {{color : 'black', marginBottom : '2px'}} min={0} max={300} value={this.state.ValeurTAC} defaultValue={this.state.ValeurTAC} onChange={(event) => this.setState({ValeurTAC: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                        <Row>
                          <Col className = "valeur_mesuree_left"  span={5} style = {{backgroundColor : "#CFE9BA", height:20}} ></Col>
                          <Col span={5} style = {{backgroundColor : "#8BE1BA"}}></Col>
                          <Col span={4} style = {{backgroundColor : "#8BBBE3"}}></Col>
                          <Col span={5} style = {{backgroundColor : "#65A5E4"}}></Col>
                          <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#3981D5"}}></Col>
                        </Row>
                        <Slider value={this.state.ValeurTAC} onChange={this.onChangeSlider.bind(this, 'ValeurTAC')} style = {{marginTop:-16}}  min={-1} max={300} defaultValue={-1}  step={1}  />
                      </div>
                    </div>
                   
                    <div className='valeur_mesuree_wrapper_item'> 
                      <h5 style = {{paddingTop:8}}>  {t('form_valeur_mesure_TH')}  <span style= {{fontWeight: 400}}>  {t('form_valeur_mesure_TH_facultatif')}</span></h5>
                      <div className = "valeur_mesuree_item">
                      <InputNumber style = {{color : 'black', marginBottom : '2px'}} min={-1} max={500} value={this.state.ValeurTH}  defaultValue={this.state.ValeurTH} onChange={(event) => this.setState({ValeurTH: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                     
                        <Row>
                          <Col className = "valeur_mesuree_left"  span={5} style = {{backgroundColor : "#8AB52B", height:20}} ></Col>
                          <Col span={5} style = {{backgroundColor : "#B3C55E"}}></Col>
                          <Col span={4} style = {{backgroundColor : "#D3DE74"}}></Col>
                          <Col span={5} style = {{backgroundColor : "#E4E89F"}}></Col>
                          <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#EBEBC6"}}></Col>
                        </Row>
                        <Slider onChange={this.onChangeSlider.bind(this, 'ValeurTH')} value = {this.state.ValeurTH} style = {{marginTop:-16}}  min={-1} max={500} defaultValue={-1}  step={1}  />
                      </div>
                    </div>

                    <div className='valeur_mesuree_wrapper_item'> 
                      <h5 style = {{paddingTop:8}}>{t('form_valeur_mesure_STAB')} <span style= {{fontWeight: 400}}> {t('form_valeur_mesure_TH_facultatif')} </span></h5>
                      <div className = "valeur_mesuree_item">
                      <InputNumber style = {{color : 'black',marginBottom : '2px'}} min={-1} max={200}  value={this.state.ValeurStabilisant}  defaultValue={this.state.ValeurStabilisant} onChange={(event) => this.setState({ValeurStabilisant: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                     
                        <Row>
                          <Col className = "valeur_mesuree_left"  span={5} style = {{backgroundColor : "#FFDED6", height:20}} ></Col>
                          <Col span={5} style = {{backgroundColor : "#F9C5B6"}}></Col>
                          <Col span={4} style = {{backgroundColor : "#FBACAD"}}></Col>
                          <Col span={5} style = {{backgroundColor : "#FD6F70"}}></Col>
                          <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#D65B5C"}}></Col>
                        </Row>
                        <Slider value={this.state.ValeurStabilisant} onChange={this.onChangeSlider.bind(this, 'ValeurStabilisant')} style = {{marginTop:-16}}  min={-1} max={200} defaultValue={-1}  step={1}  />
                      </div>
                    </div>

                    <div className='valeur_mesuree_wrapper_item'> 
                      <h5 style = {{paddingTop:8}}> {t('form_valeur_mesure_Phosphate')}   <span style= {{fontWeight: 400}}> {t('form_valeur_mesure_TH_facultatif')} </span></h5>
                      <div className = "valeur_mesuree_item">
                      <InputNumber style = {{color : 'black',marginBottom : '2px'}} min={-1} max={2500}  value={this.state.ValeurPhosphate}  defaultValue={this.state.ValeurPhosphate} onChange={(event) => this.setState({ValeurPhosphate: event})} parser={(value) => value.replace(',', '.')} formatter={(value) => value.replace('.', ',')}/>
                    
                        <Row>
                          <Col className = "valeur_mesuree_left"  span={5} style = {{backgroundColor : "#FFF8D4", height:20}} ></Col>
                          <Col span={5} style = {{backgroundColor : "#FAE5BB"}}></Col>
                          <Col span={4} style = {{backgroundColor : "#DFCABB"}}></Col>
                          <Col span={5} style = {{backgroundColor : "#CBB983"}}></Col>
                          <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#A49A79"}}></Col>
                        </Row>
                        <Slider value={this.state.ValeurPhosphate} onChange={this.onChangeSlider.bind(this, 'ValeurPhosphate')} style = {{marginTop:-16}}  min={-1} max={2500} defaultValue={-1}  step={1}  />
                      </div>
                    </div>

                  </div>
                  )}

                </div>

                <div className = "buttonForm">
                      <Button className = 'buttonFormStyleEspritPiscine'  onClick={this.validationFormulaire} 
                      loading = {this.state.loadingButton} 
                      size={"large"} 
                      style={{borderRadius : 10, fontWeight:600, paddingLeft:50, paddingRight:50, marginBottom: 30, borderColor: 'white', backgroundColor: '#0C4457', color:'#FFFFFF'}}>{t('form_valeur_button')} </Button>
                </div>
               
              

              </div>
            </div>

            <Footer />
        </div>
      )

    };
}


export default withTranslation() (AvaForms);
